module.exports = __webpack_public_path__ + "static/onset-e381f72d0909b56fbd9a975662fd7e4b.jpg";